import { render } from "./App.vue?vue&type=template&id=37eaf7b6"
const script = {}

import "./App.vue?vue&type=style&index=0&id=37eaf7b6&lang=scss"

import exportComponent from "D:\\Project\\Code\\trueway\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__